import tabs from '../../../common/components/tabs/tabs.vue';
import lahiCalculatorForm from './lahi-calculator-form/lahi-calculator-form.vue';
import VueTab from '@ui-common/vue-tab';
import { mapState } from 'vuex';
const GREY = 'grey';
export default {
	extends: tabs,
	data() {
		return {
			isSliderOnLeftEnd: false,
			isSliderOnRightEnd: false
		};
	},
	props: {
		calculatorTitle: {}
	},
	components: {
		lahiCalculatorForm,
		VueTab
	},
	computed: {
		...mapState('lahi', ['calculatorTabs', 'backendInitData']),
		GREY() {
			return GREY;
		}
	},
	watch: {
		selectedTabIndex(newValue) {
			if (typeof newValue == 'number') {
				this.$emit('on-tab-change', newValue);
			}
		}
	},
	methods: {
		calculate(data) {
			this.$emit('on-calculate', data);
		},
		setScroller() {
			this.isSliderOnLeftEnd = this.$refs.tabContainer.scrollLeft == 0;
			this.isSliderOnRightEnd = this.tabsWrapperWidth - this.$refs.tabContainer.offsetWidth == this.$refs.tabContainer.scrollLeft;
		},
		onScroll() {
			this.tabsWrapperWidth = this.$refs.tabContainer.offsetWidth;
			this.setScroller();
		}
	},
	mounted() {
		if (this.calculatorTabs && this.calculatorTabs.length > 1) {
			this.setScroller();
			this.$refs.tabContainer.addEventListener('scroll', this.onScroll);
			window.addEventListener('resize', this.onScroll);
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onScroll);
	}
};
